import { FEEDBACK_PROMPT_SOURCE } from 'constants/feedback-prompt'
import { callSentryWithFirebaseError } from 'utils/sentry/call-sentry-with-firebase-error'

export interface ProductFeedbackPayload {
  userId?: string
  email?: string
  timestamp: number
  feedback: string
  source: typeof FEEDBACK_PROMPT_SOURCE
}

/**
 * Firebase Realtime Database rejects objects that contain `undefined` values.
 */
const toFirebaseSafePayload = (feedbackData: ProductFeedbackPayload): Record<string, string | number> => {
  const { userId, email, timestamp, feedback, source } = feedbackData

  return {
    timestamp,
    feedback,
    source,
    ...(userId ? { userId } : {}),
    ...(email ? { email } : {}),
  }
}

export const saveProductFeedback = async (feedbackData: ProductFeedbackPayload): Promise<void> => {
  const fireDb = await import('firebase/database')
  const { getDatabase, ref, push } = fireDb

  const feedbackRef = ref(getDatabase(), 'userProductFeedback')

  push(feedbackRef, toFirebaseSafePayload(feedbackData)).catch(callSentryWithFirebaseError)
}
